import { render, staticRenderFns } from "./ThePaginator.vue?vue&type=template&id=4a82c78e&"
import script from "./ThePaginator.vue?vue&type=script&lang=ts&"
export * from "./ThePaginator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports